
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { TemplateItemProps } from ".";
import { loading, find } from "store/template";

interface ApiTemplateFindByIdInputProps {
    id: number;
}

type ApiTemplateFindOutputProps = OutputBaseProps<{ item: TemplateItemProps; }, ApiTemplateFindByIdInputProps>

export const apiTemplateFindById = async (data: ApiTemplateFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiTemplateFindOutputProps>(`/api/template/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiTemplateFindByCodeInputProps {
    code: string;
}

export const apiTemplateFindByCode = async (data: ApiTemplateFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiTemplateFindOutputProps>(`/api/template/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};